import { Icon } from "../../../components/Icon/Icon.tsx";
import { useImageDropZone } from "../../../hooks/useImageDropZone.ts";
import { useAppMutation } from "../../../http/useAppMutation.ts";
import { useUploadImage } from "../../Board/hooks/useUploadImage.ts";
import { BrandLogoItem } from "../../components/BrandLogoItem.tsx";
import { UPLOAD_MAX_IMAGE_SIZE } from "../../constants.ts";
import { useWorkspaceLogos } from "../../hooks/useWorkspaceLogos.ts";
import { useWorkspaceUuid } from "../../hooks/useWorkspaceUuid.ts";
import { BrandDeletionButton } from "./components/BrandDeletionButton.tsx";
import { BrandKitSection } from "./components/BrandKitSection.tsx";

export const BrandLogoSection = () => {
  const workspaceUuid = useWorkspaceUuid();

  const { mutate: createBrandLogo, isLoading: isCreatingBrandLogo } =
    useAppMutation({
      path: `workspaces/${workspaceUuid}/brand-logos`,
      invalidate: [`workspaces/${workspaceUuid}`],
    }).mutation;

  const { mutate: uploadImage, isLoading: isUploadingImage } = useUploadImage({
    onSuccess: (imageUuid) => {
      createBrandLogo({ image_uuid: imageUuid });
    },
    pipelineCompatible: false,
    maxSize: UPLOAD_MAX_IMAGE_SIZE,
  });

  const {
    getInputProps,
    getRootProps,
    open: openImageDropZone,
  } = useImageDropZone({
    multiple: false,
    minImageSize: 1,
    onImageValidated: (file) => {
      if (file) uploadImage({ image: file.fileToUpload });
    },
    acceptSvg: true,
  });

  const brandLogos = useWorkspaceLogos();

  return (
    <BrandKitSection
      title="Logos"
      onAdd={openImageDropZone}
      isLoading={isUploadingImage || isCreatingBrandLogo}
    >
      {brandLogos.length > 0 ? (
        <div className="flex-row items-center gap-200">
          {brandLogos.map((brand, index) => (
            <div key={index} className="relative group">
              <BrandLogoItem brand={brand} className="h-[150px]" />
              <div className="absolute right-100 top-100 invisible group-hover:visible">
                <BrandDeletionButton brandUuid={brand.uuid} />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div
          className="max-h-[250px] flex-row-center w-full p-800 gap-400 rounded-300 border-025 border-dashed border-input-border-rest"
          {...getRootProps()}
        >
          <input {...getInputProps()} />
          <Icon name="CloudUpload" size="lg" />
          <span className="body-md-default text-secondary">
            Add your brand logos for easy access anywhere in the app. Drop a
            file or select an image.
          </span>
        </div>
      )}
    </BrandKitSection>
  );
};
